<template>
  <div>{{ value | anyDate(unit) }}</div>
</template>

<script>
  export default {
    props: ['value', 'unit'],
    created() {
      if (!this.value) {
        let now = moment().unix()
        this.$emit('input', now)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// honrayDealtime.vue?ab1cffe0